import React, { useRef } from 'react';
import { Form } from 'react-final-form';
import HiddenInput from '../../components/SDL/HiddenInput';
import { useConfiguration } from '../../providers/Configuration';
import { getFormTarget, searchToObject } from '../../services/common.service';
import ButtonContainer from '../ButtonContainer';
import FormFieldList from '../FormFieldList';
import SecondButtonContainer from '../SecondButtonContainer';
import GdprTextContainer from '../GdprTextContainer';
import LinkOnlyBanner from '../LinkOnlyBanner';
import { isLinkOnlyMode } from '../helpers/linkOnlyMode';
import { hasGdprFields } from '../helpers/showGdprText';

export default function DynamicWithoutService() {
    const {
        configuration: {
            componentData: {
                buttonText,
                formFieldList: fields,
                productflowUrl,
                encryptJSParam,
                windowType,
                formMethod,
                categoryServiceUrl,
                linkBtnApplication
            }
        }
    } = useConfiguration();

    const secondButtonLink = linkBtnApplication?.Url;
    const secondButtonText = linkBtnApplication?.LinkText;
    const formRef = useRef(null);
    /**
     * the target i.e should it open in _self, _blank or target the iframe 'product-iframe'
     */
    const target = getFormTarget({ windowType, encryptJSParam });

    /**
     * copied over from old angular application
     */
    const { agentId: agentID, caseId: caseID } = searchToObject(window.location.search);

    /**
     * Split up fields into hidden and visible for layout purposes
     */
    const { hiddenFields, visibleFields } = (fields || []).reduce(
        (acc, field) => {
            if (field.inputControl === 'Hidden') {
                acc.hiddenFields.push(field);
                return acc;
            } else {
                acc.visibleFields.push(field);
                return acc;
            }
        },
        { hiddenFields: [], visibleFields: [] }
    );

    if (isLinkOnlyMode({ linkBtnApplication, visibleFields })) {
        return <LinkOnlyBanner linkBtnApplication={linkBtnApplication} fallbackButtonText={buttonText} />;
    }

    const showGdprText = hasGdprFields(fields);

    function onSubmit(data, api, ...rest) {
        /**
         * First we handle the case of a new react flow
         */
        if (encryptJSParam) {
            const encodedParams = encodeURIComponent(btoa(JSON.stringify(data)));
            const actionurl = productflowUrl + '?params=' + encodedParams;
            window.open(actionurl, target);
            return;
        }
        /**
         * if the target is `product-iframe` aslong as we are using FDRs modal component we first need to trigger this
         * to create the iframe.
         */
        if (target === 'product-iframe') {
            // eslint-disable-next-line no-undef
            fdr.modal.open(productflowUrl, true, target);
        }

        /**
         * Final submit
         */
        if (formMethod === 'SESSION') {
            sessionStorage.setItem('data', JSON.stringify(data));
            window.location.assign(productflowUrl);
        } else formRef.current.submit();
    }
    return (
        <>
            <Form onSubmit={onSubmit}>
                {({ handleSubmit }) => {
                    return (
                        <form
                            autocomplete="off"
                            onSubmit={handleSubmit}
                            name={'productForm'}
                            action={productflowUrl}
                            method={formMethod}
                            target={target}
                            ref={formRef}
                        >
                            {agentID && <HiddenInput name={`agentId`} value={agentID} id={`agentId`} />}
                            {caseID && <HiddenInput name={`caseId`} value={caseID} id={`caseId`} />}
                            {hiddenFields.map((field, index) => (
                                <HiddenInput {...field} key={index} />
                            ))}
                            <FormFieldList
                                fields={visibleFields}
                                categoryServiceUrl={categoryServiceUrl}
                            ></FormFieldList>

                            <ButtonContainer buttonText={buttonText} />
                        </form>
                    );
                }}
            </Form>
            {secondButtonText && secondButtonLink && (
                <SecondButtonContainer buttonText={secondButtonText} buttonLink={secondButtonLink} />
            )}
            {showGdprText && <GdprTextContainer />}
        </>
    );
}
